import { useRouter } from 'next/router';
import { CiSearch } from 'react-icons/ci';
import classNames from '@/lib/classNames';
export default function NotAuthMobileNav({
  className
}: {
  className?: string;
}) {
  const router = useRouter();
  return <div className={classNames('w-full flex-grow lg:hidden fixed top-0 bg-genius-indigo z-50', className)} data-sentry-component="NotAuthMobileNav" data-sentry-source-file="NotAuthMobileNav.tsx">
      <div className='flex h-16 w-full items-center justify-between px-2 gap-1'>
        <div className='flex items-center gap-1 rounded-md w-full bg-genius-blue py-5 h-6 px-2 text-genius-cream/50 font-sans font-light text-sm' onClick={() => router.push('/explore')}>
          <CiSearch data-sentry-element="CiSearch" data-sentry-source-file="NotAuthMobileNav.tsx" />
          {'Search for an asset'}
        </div>
      </div>
    </div>;
}